import {useToast} from 'primevue/usetoast'
import {errorsMessages} from 'assets/errors'
import {AxiosError} from 'axios'

const DEFAULT_LIFE = 10 * 1000

export const useNotification = function (life = DEFAULT_LIFE) {
  const toast = useToast()

  const showNotification = (severity, summary = '', detail = '') => {
    toast.add({ severity, summary, life, detail, group: 'tc' })
  }

  return {
    showError(error) {
      const detail = getErrorMessage(error)
      return showNotification('error', '', detail)
    },
    showSuccess(summary = 'Operation successful', detail = '') {
      return showNotification('success', summary, detail)
    },
    showWarn(summary = 'Warning', detail = '') {
      return showNotification('warn', summary, detail)
    },
    showInfo(summary = 'Information', detail = '') {
      return showNotification('info', summary, detail)
    },
    showSecondary(summary = 'Secondary', detail = '') {
      return showNotification('secondary', summary, detail)
    }
  }
}

function getErrorMessage(error) {
  if(error instanceof AxiosError) {
    const errorResponseData = error.response?.data

    if(errorsMessages?.[errorResponseData?.detail]) {
      return errorsMessages[errorResponseData?.detail]
    } else{
      return errorResponseData?.detail || error.message
    }
  }

  if (error && error.message && errorsMessages?.[error.message]) {
    return errorsMessages[error.message]
  }

  return error?.message || error
}
